import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-identity',
  templateUrl: './identity.component.html',
  styleUrl: './identity.component.scss',
})
export class IdentityComponent {}
